import { render, staticRenderFns } from "./DeviceAnalysis.vue?vue&type=template&id=0ffc4c85&scoped=true"
import script from "./DeviceAnalysis.vue?vue&type=script&lang=js"
export * from "./DeviceAnalysis.vue?vue&type=script&lang=js"
import style0 from "./DeviceAnalysis.vue?vue&type=style&index=0&id=0ffc4c85&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffc4c85",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ffc4c85')) {
      api.createRecord('0ffc4c85', component.options)
    } else {
      api.reload('0ffc4c85', component.options)
    }
    module.hot.accept("./DeviceAnalysis.vue?vue&type=template&id=0ffc4c85&scoped=true", function () {
      api.rerender('0ffc4c85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DeviceAnalysis/DeviceAnalysis.vue"
export default component.exports